package feature.cart.viewModel

import feature.app.AppViewModel
import feature.cart.repository.CartRepository
import feature.product.handler.ProductHandler
import feature.product.model.Product
import kotlinx.coroutines.flow.StateFlow

class CartViewModel(private val repository: CartRepository) : AppViewModel() {

    val cartProducts: StateFlow<List<Product>>
        get() = repository.cartProducts

//    val cart: StateFlow<JsonObject>
//        get() = repository.cart

    val cartCount: StateFlow<Int>
        get() = repository.cartCount

    val mrp: StateFlow<Float>
        get() = repository.mrp

    val discount: StateFlow<Float>
        get() = repository.discount

    val price: StateFlow<Float>
        get() = repository.price

    val subtotal: StateFlow<Float>
        get() = repository.subtotal

    val tax: StateFlow<Float>
        get() = repository.tax

    val instantDiscount: StateFlow<Float>
        get() = repository.instantDiscount

    val totalAmount: StateFlow<Float>
        get() = repository.totalAmount


    private fun updateProductsInCart() {
        var productsAddedToCart: ArrayList<Product> = arrayListOf()
        ProductHandler.shared().repository.allProduct.value.forEach {
    //            if (cart.value?.has(it.Id) == true) {
    //                productsAddedToCart.add(it)
    //            }
        }
//        repository.cartProductLiveData.postValue(productsAddedToCart)
        updatePricesInCart()
    }

    fun updateInstantDiscount(amount: Float) {
//        repository.instantDiscountLiveData.postValue(amount)
    }

    fun updatePricesInCart() {
        var totalMrp = 0F
        var price = 0F
        var priceDiscount = 0F
        var totalTax = 0F
        var priceTotal = 0F
        var instantDiscountPrice = 0F
//        cartProducts.value?.forEach {
//            val quanity = getProductQuantity(it)
//            if (it.ProductPrice?.Price != null) {
//                price += (it.ProductPrice?.Price!! * quanity)
//            }
//            if (it.ProductPrice?.Discount != null) {
//                priceDiscount += (it.ProductPrice?.Discount!! * quanity)
//            }
//            if (it.ProductPrice?.FinalPrice != null) {
//                priceTotal += (it.ProductPrice?.FinalPrice!! * quanity)
//            }
//            if (it.ProductPrice?.MRP != null) {
//                totalMrp += (it.ProductPrice?.MRP!! * quanity)
//            }
//        }
        if (instantDiscount.value != null) {
            instantDiscountPrice = instantDiscount.value
        }
        totalTax = priceTotal - price
        priceTotal -= instantDiscountPrice
//        repository.subtotalLiveData.postValue(price + totalTax)
//        repository.discountLiveData.postValue(priceDiscount)
//        repository.taxLiveData.postValue(totalTax)
//        repository.totalAmountLiveData.postValue(priceTotal)
//        repository.mrpLiveData.postValue(totalMrp)
//        repository.priceLiveData.postValue(price)
    }

//    fun updateCount() {
//        var count = 0
//        cart.value?.keys()?.forEach {
//            count += 1
//        }
//        repository.cartCountLiveData.postValue(count)
//    }

//    fun getProductQuantity(product: Product): Int {
//        var quanity = 0
//        if (cart.value != null && cart.value!!.has(product.Id)) {
//            quanity = cart.value!!.getInt(product.Id)
//        }
//        return quanity
//    }
//
//    fun getProductPrice(product: Product): Float {
//        return product.ProductPrice!!.FinalPrice!! * getProductQuantity(product)
//    }
//
//
//    fun resetCart() {
//        repository.cartProductLiveData.postValue(arrayListOf())
//        repository.cartLiveData.postValue(JSONObject())
//        repository.cartCountLiveData.postValue(0)
//        repository.discountLiveData.postValue(0F)
//        repository.subtotalLiveData.postValue(0F)
//        repository.taxLiveData.postValue(0F)
//        repository.instantDiscountLiveData.postValue(0F)
//        repository.totalAmountLiveData.postValue(0F)
//    }
//
//    fun prepareOrderDetails(customer: Customer?): JSONObject? {
//        val unixTime = Clock.System.now().epochSeconds
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business.value
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business?.Id)
//        val invoiceId = System.currentTimeMillis()
//        val transactions = prepareTransaction(customer, invoiceId)
//
//        if (CustomerHandler.shared().repository.customer.value != null) {
//            val customerJson = gson.toJson(CustomerHandler.shared().repository.customer.value)
//            request.put(KeyConstant.customer, JSONObject(customerJson))
//        }
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.orderItems, transactions.first)
//        if (transactions.first.length() == 0) {
//            return null
//        }
//        request.put(KeyConstant.orderId, unixTime)
//        request.put(KeyConstant.pricing, transactions.second)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.mobileNumber, user.mobile)
//        request.put(KeyConstant.dialCode, user.dialCode)
//        request.put(KeyConstant.businessID, business?.Id)
//        request.put(KeyConstant.toBusinessID, business?.Id)
//        request.put(KeyConstant.business, JSONObject(gson.toJson(business)))
//        request.put(KeyConstant.instantDiscount, instantDiscount.value)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        if (CustomerHandler.shared().repository.customer.value != null) {
//            val customerJson = gson.toJson(CustomerHandler.shared().repository.customer.value)
//            request.put(KeyConstant.customer, JSONObject(customerJson))
//        }
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        return request
//    }
//
//    fun createInvoice(customer: Customer?) {
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business.value
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business?.Id)
//
//        val invoiceId = System.currentTimeMillis()
//        val transactions = prepareTransaction(customer, invoiceId)
//
//        if (CustomerHandler.shared().repository.customer.value != null) {
//            val customerJson = gson.toJson(CustomerHandler.shared().repository.customer.value)
//            request.put(KeyConstant.customer, JSONObject(customerJson))
//        }
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        if (transactions.first.length() == 0) {
//            return
//        }
//        request.put(KeyConstant.sales, transactions.first)
//        request.put(KeyConstant.pricing, transactions.second)
//        request.put(KeyConstant.invoiceId, invoiceId)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business?.Id)
//        request.put(KeyConstant.business, JSONObject(gson.toJson(business)))
//        request.put(KeyConstant.instantDiscount, instantDiscount.value)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        if (CustomerHandler.shared().repository.customer.value != null) {
//            val customerJson = gson.toJson(CustomerHandler.shared().repository.customer.value)
//            request.put(KeyConstant.customer, JSONObject(customerJson))
//        }
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//    }
//
//
//    fun prepareTransaction(customer: Customer?, invoiceId: Long): Pair<JSONArray, JSONObject> {
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business
//        val transactions = JSONArray()
//        val pricingDetails = JSONObject()
//        var totalIGST = 0
//        var totalCGST = 0
//        var totalSGST = 0
//        var totalVAT = 0
//        var totalCESS = 0
//        var totalTax = 0
//        var totalCostPrice = 0F
//        var totalPrice = 0F
//        var totalFinalPrice = 0F
//        if (cartProducts.value != null && cartProducts.value!!.isNotEmpty()) {
//            cartProducts.value?.forEach {
//                val gson = Gson()
//                val productData = JSONObject(gson.toJson(it))
//                val transactionData = JSONObject()
//                transactionData.put(KeyConstant.userId, user._id)
//                transactionData.put(KeyConstant.businessID, business.value!!.Id)
//                if (customer != null) {
//                    transactionData.put(KeyConstant.customerID, customer.Id)
//                    transactionData.put(KeyConstant.customerName, customer.Name)
//                    transactionData.put(KeyConstant.customerMobile, customer.MobileNumber)
//                    transactionData.put(KeyConstant.vehicleNumber, customer.DeviceID)
//                }
//                val quanity = getProductQuantity(it)
//                var IGST = 0
//                var CGST = 0
//                var SGST = 0
//                var VAT = 0
//                var CESS = 0
//                var Tax = 0
//                var mrp = 0F
//                var finalPrice =
//                    it.ProductPrice?.FinalPrice?.times(quanity) ?: it.ProductPrice?.FinalPrice
//                var costPrice = 0f
//                if (it.ProductPrice?.CostPrice != null) {
//                    costPrice = it.ProductPrice!!.CostPrice!! * quanity.toFloat()
//                    totalCostPrice += costPrice
//                }
//                if (it.ProductPrice?.Price != null) {
//                    mrp = it.ProductPrice!!.Price!! * quanity.toFloat()
//                    totalPrice += mrp
//                }
//                if (it.ProductPrice?.FinalPrice != null) {
//                    finalPrice = it.ProductPrice!!.FinalPrice!! * quanity.toFloat()
//                    totalFinalPrice += finalPrice
//                }
//                if (it.ProductPrice?.IGST != null) {
//                    IGST = it.ProductPrice?.IGST!!.toInt() * quanity
//                    totalIGST += IGST
//                }
//                if (it.ProductPrice?.CGST != null) {
//                    CGST = it.ProductPrice?.CGST!!.toInt() * quanity
//                    totalCGST += CGST
//                }
//                if (it.ProductPrice?.SGST != null) {
//                    SGST = it.ProductPrice?.SGST!!.toInt() * quanity
//                    totalSGST += SGST
//                }
//                if (it.ProductPrice?.VAT != null) {
//                    VAT = it.ProductPrice?.VAT!!.toInt() * quanity
//                    totalVAT += VAT
//                }
//                if (it.ProductPrice?.CESS != null) {
//                    CESS = it.ProductPrice?.CESS!!.toInt() * quanity
//                    totalCESS += CESS
//                }
//                if (it.ProductPrice?.TaxIncluded != null && !it.ProductPrice?.TaxIncluded!! && it.ProductPrice?.Tax != null) {
//                    Tax = it.ProductPrice?.Tax!!.toInt()
//                    totalTax += Tax
//                }
//                transactionData.put(KeyConstant.invoiceId, invoiceId)
//                transactionData.put(KeyConstant.productID, it.Id)
//                transactionData.put(KeyConstant.productName, it.Name)
//                transactionData.put(KeyConstant.product, productData)
//                transactionData.put(KeyConstant.mode, "CASH")
//                transactionData.put(KeyConstant.quantity, quanity)
//                transactionData.put(KeyConstant.IGST, IGST)
//                transactionData.put(KeyConstant.CGST, CGST)
//                transactionData.put(KeyConstant.SGST, SGST)
//                transactionData.put(KeyConstant.VAT, VAT)
//                transactionData.put(KeyConstant.CESS, CESS)
//                transactionData.put(KeyConstant.tax, Tax)
//                transactionData.put(KeyConstant.price, it.ProductPrice?.Price)
//                transactionData.put(
//                    KeyConstant.finalPrice,
//                    finalPrice
//                )
//                transactionData.put(KeyConstant.costPrice, it.ProductPrice?.CostPrice)
//                transactionData.put(KeyConstant.saleDate, now())
//                transactionData.put(KeyConstant.discount, it.ProductPrice?.Discount)
//                transactionData.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//                if (customer != null && !customer.Id.isEmpty()) {
//                    transactionData.put(KeyConstant.customerName, customer.Name)
//                    transactionData.put(KeyConstant.customerMobile, customer.MobileNumber)
//                    transactionData.put(KeyConstant.customerID, customer.Id)
//                }
//                transactions.put(transactionData)
//            }
//        }
//        pricingDetails.put(KeyConstant.IGST, totalIGST)
//        pricingDetails.put(KeyConstant.CGST, totalCGST)
//        pricingDetails.put(KeyConstant.SGST, totalSGST)
//        pricingDetails.put(KeyConstant.VAT, totalVAT)
//        pricingDetails.put(KeyConstant.CESS, totalCESS)
//        pricingDetails.put(KeyConstant.tax, totalTax)
//        pricingDetails.put(
//            KeyConstant.finalPrice,
//            totalFinalPrice
//        )
//        pricingDetails.put(KeyConstant.costPrice, totalCostPrice)
//        pricingDetails.put(KeyConstant.price, totalPrice)
//        return Pair(transactions, pricingDetails)
//    }
//
//    fun now(): String {
//        return SimpleDateFormat("yyyy-MM-dd HH:mm:ss", Locale.getDefault()).format(Date())
//    }
//
//    fun addToCart(product: Product) {
//        var allCartItem = repository.cartLiveData.value
//        val random = (0..10).random()
//        if (allCartItem != null) {
//            if (allCartItem.has(product.Id)) {
//                var quantity = allCartItem.getInt(product.Id)
//                quantity += 1
//                allCartItem.remove(product.Id)
//                allCartItem.put(product.Id, quantity)
//            } else {
//                allCartItem.put(product.Id, 1)
//            }
//            repository.cartLiveData.postValue(allCartItem)
//        } else {
//            val newCart = JSONObject()
//            newCart.put(product.Id, 1)
//            repository.cartLiveData.postValue(newCart)
//        }
//        updateCount()
//        updateProductsInCart()
//    }
//
//    fun addToCart(product: Product, quantity: Int) {
//        var allCartItem = repository.cartLiveData.value
//        if (allCartItem != null) {
//            if (allCartItem.has(product.Id)) {
//                var existingQuantity = allCartItem.getInt(product.Id)
//                existingQuantity += quantity
//                allCartItem.put(product.Id, quantity)
//            } else {
//                allCartItem.put(product.Id, quantity)
//            }
//            repository.cartLiveData.postValue(JSONObject())
//            repository.cartLiveData.postValue(allCartItem)
//            repository.cartLiveData.postValue(allCartItem)
//            repository.cartLiveData.postValue(allCartItem)
//        } else {
//            val newCart = JSONObject()
//            newCart.put(product.Id, quantity)
//            repository.cartLiveData.postValue(JSONObject())
//            repository.cartLiveData.postValue(newCart)
//            repository.cartLiveData.postValue(newCart)
//            repository.cartLiveData.postValue(newCart)
//        }
//        updateCount()
//        updateProductsInCart()
//    }
//
//    fun addToCart(barCode: String, callBack: (message: String) -> Unit) {
//        ProductHandler.shared().viewModel?.findProductByBarCode(barCode) { prd: Product? ->
//            prd?.let {
//                addToCart(it)
//                callBack("Added to cart")
//            }
//        }
//    }
//
//    fun removeFromCart(product: Product) {
//        var allCartItem = repository.cartLiveData.value
//        if (allCartItem != null) {
//            if (allCartItem.has(product.Id)) {
//                var quantity = allCartItem.getInt(product.Id)
//                quantity -= 1
//                if (quantity < 1) {
//                    allCartItem.remove(product.Id)
//                } else {
//                    allCartItem.put(product.Id, quantity)
//                }
//            }
//            repository.cartLiveData.postValue(allCartItem)
//        }
//        updateCount()
//        updateProductsInCart()
//    }
}